import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Loader } from 'components/Shared/Loader'
import { ExpandableLayout } from 'components/Shared/ExpandableLayout'
import { useTranslation } from 'react-i18next'
import { useContractorUpdateHistory } from '../hooks'
import { Link } from 'components/Shared/Link'
import { ContractorHistoryRow } from './ContractorHistoryRow'
import { useHistory } from 'react-router-dom'

const ROW_HEIGHT = 48
const COLLAPSED_ROWS_COUNT = 3

const useStyles = makeStyles({
  container: {
    padding: '16px 34px'
  },
  content: {
    minHeight: ROW_HEIGHT * COLLAPSED_ROWS_COUNT
  },
  list: {
    overflowX: 'auto'
  }
})

export const ContractorHistory = ({ contractorId }) => {
  const { updateHistory, updateHistoryLoading } = useContractorUpdateHistory(contractorId)
  const classes = useStyles()
  const { t } = useTranslation()
  const history = useHistory()

  const handleShowEditHistoryClick = (record) => {
    history.push(`/contractors/edit-history/${contractorId}?version=${record.version}`)
  }

  const formatTitle = (title, responsibleUser) => {
    const formattedResponsibleUser = responsibleUser ? t('contractor.details.history.record.by') + ' ' + responsibleUser.firstName + ' ' + responsibleUser.lastName : ''
    return t(title) + ' ' + formattedResponsibleUser
  }

  const renderContent = () => {
    if (updateHistoryLoading) {
      return <Loader/>
    }
    if (!updateHistory) {
      return null
    }

    const initialRecord = updateHistory[0]
    const updateRecords = updateHistory.slice(1, updateHistory.length).reverse()

    return (
      <ExpandableLayout showExpandIcon={updateHistory.length > COLLAPSED_ROWS_COUNT}
                        collapsedHeight={COLLAPSED_ROWS_COUNT * ROW_HEIGHT}
                        expandedText={t('contractor.details.history.collapse')}
                        collapsedText={t('contractor.details.history.expand')}>
        <div className={classes.list}>
          {
            updateRecords.map(record =>
              <ContractorHistoryRow
                key={record.version}
                title={formatTitle('contractor.details.history.record.action.contractorUpdated', record.responsibleUser)}
                action={
                  <Link title={t('contractor.details.history.action.showEditHistory')}
                        onClick={() => handleShowEditHistoryClick(record)}/>
                }
                dateTime={record.updateDateTime}/>
            )
          }
          <ContractorHistoryRow
            title={formatTitle('contractor.details.history.record.action.contractorCreated', initialRecord.responsibleUser)}
            dateTime={initialRecord.updateDateTime}/>
        </div>
      </ExpandableLayout>
    )
  }

  return (
    <div className={classes.container}>
      <h2>{t('contractor.details.history.title')}</h2>
      <div className={classes.content}>
        {renderContent()}
      </div>
    </div>
  )
}